import * as React from "react";
function SvgSpeaker(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M48 5.3L5.3 18.7H0v10.7h5.3l5.7 1.8c-.3 1.3-.2 2.7.4 4 .6 1.5 1.9 2.7 3.4 3.2.6.2 1.2.3 1.9.3 1 0 1.9-.2 2.8-.7 1.3-.7 2.3-1.9 2.9-3.3l25.6 8V5.3zM18.3 35.6c-1.5.8-3.4.3-4.2-1.2-.1-.1-.1-.2-.2-.3-.3-.7-.4-1.4-.3-2.1l6.3 2c-.4.6-.9 1.2-1.6 1.6zm27 3.4L6.1 26.8l-.4-.1h-3v-5.3h3.1l.4-.1L45.3 9v30z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgSpeaker);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
